import { useState } from 'react'

import { Typography } from 'antd'

import { DraggableModal } from '@eastcoal/common/components/DraggableModal'
import { browserRedirect } from '@eastcoal/common/utils/browser'

import { FormItem } from '@eastcoal/formily/components/FormItem'
import { Input } from '@eastcoal/formily/components/Input'
import { SchemaForm } from '@eastcoal/formily/components/SchemaForm'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'
import { useCreationForm } from '@eastcoal/formily/hooks/useCreationForm'

import { LoginMfaProps } from './interface'

const schema: SchemaItem[] = [
  {
    name: 'mfaCode',
    type: 'string',
    title: '安全码',
    required: true,
    'x-component': Input,
    'x-component-props': {
      placeholder: '请输入6位验证码',
      autoComplete: 'off'
    },
    'x-decorator': FormItem
  }
]

export const LoginMfaModal = ({
  api,
  user,
  open,
  onOpenChange
}: LoginMfaProps) => {
  const [loading, setLoading] = useState(false)
  const form = useCreationForm({
    initialValues: {
      userId: user?.id
    }
  })

  if (!user) {
    return null
  }

  const handleSubmit = () => {
    form.submit(async values => {
      try {
        setLoading(true)
        await api(values)
        browserRedirect()
      } finally {
        setLoading(false)
      }
    })
    return false
  }

  return (
    <DraggableModal
      open={open}
      title='登录身份验证'
      okButtonProps={{
        loading
      }}
      onOk={handleSubmit}
      onOpenChange={onOpenChange}
    >
      <Typography.Paragraph>
        <span>为确保账号&nbsp;</span>
        <Typography.Text type='warning'>{user.phone}</Typography.Text>
        <span>
          &nbsp;是您本人操作，请输入您绑定的安全设备APP上的动态安全码。
        </span>
      </Typography.Paragraph>
      <SchemaForm form={form} name='loginMfaForm' schema={schema} />
    </DraggableModal>
  )
}
